import uuid4 from "uuid4";

export default class Loan {
	constructor() {
		this.LoanGuid = uuid4();
		this.LoanName = null;
		this.IncludeMortgageProtectionPolicy = null;
		this.PolicyRecommendation = null;
		this.ReplyOnAdvice = null;
		this.ToldPolicyEssential = null;
		this.AlreadyHadDeathDisabilityIncomeProtectionCover = null;
		this.DocumentProvided = null;
		this.Documents = [];
	}
}
